import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { loadDynamicProductForms } from "./lib/productFormData";

// Admin-added standard product types (non-blocking; pickers read them at render).
void loadDynamicProductForms();

createRoot(document.getElementById("root")!).render(<App />);
